import { useCallback, useState } from 'react'
import useSWR from 'swr'
import { createContainer } from 'unstated-next'
import { BatchTimingsSchema } from '../Schema'
import DashboardBatchesStore from './DashboardBatchesStore'
import { notify } from '../../../../../../../Helpers/Notifications'
import {
  batchNotifyEmail,
  cancelRegistration,
  classReschedule,
  processCourseRegistration,
} from '../../../../../../../API/Course'

const BatchTimingsStore = createContainer(() => {
  const [batchId, setBatchId] = useState(null)
  const [userType, setUserType] = useState('')

  const { mutate: mutateBatches } = DashboardBatchesStore.useContainer()

  const { data: batchTimings, error, mutate } = useSWR(
    !batchId ? null : [`/course/batch/${batchId}`, BatchTimingsSchema],
  )

  const deleteRegistration = useCallback(
    async (id) => {
      const success = await cancelRegistration(id)

      if (success) {
        await mutate()
        await mutateBatches()
        notify('success', 'Student de-registered successfully')
      }

      return success
    },
    [mutate, mutateBatches],
  )

  const processRegistration = useCallback(
    async (id, data) => {
      const success = await processCourseRegistration(id, data)

      if (success) {
        await mutate()
        await mutateBatches()
        notify(
          'success',
          `Enrollment request ${
            data.status === 'APPROVED' ? `approved` : `rejected`
          } successfully.`,
        )
      }

      return success
    },
    [mutate, mutateBatches],
  )

  const rescheduleClass = useCallback(
    async (data) => {
      console.log({ data })
      const success = await classReschedule(data)

      if (success) {
        await mutate()
        await mutateBatches()
        notify(
          'success',
          data?.extraClass
            ? 'Class created successfully.'
            : 'Class rescheduled successfully.',
        )
      }
      return success
    },
    [mutate, mutateBatches],
  )

  const notifyEmail = useCallback(
    async (message) => {
      const data = {
        body: message,
        paid: true,
        notPaid: false,
        requested: false,
      }
      const success = await batchNotifyEmail(batchId, data)

      if (success) {
        notify('success', 'Sent the message successfully.')
      }

      return success
    },
    [batchId],
  )

  return {
    loading: !batchTimings,
    loadFailed: !!error,
    batchId,
    setBatchId,
    batchTimings,
    userType,
    setUserType,
    deleteRegistration,
    processRegistration,
    rescheduleClass,
    notifyEmail,
  }
})

export default BatchTimingsStore
